export default "<app-report-stock\n[customers]=\"customers\"\n(exportExcel)=\"onExportExcel($event)\">\n</app-report-stock>\n"